import { axiosService } from "../axios.service";
import { urls } from "../../constants";

const adminUsersService = {
  createOrUpsert: (data) =>
    axiosService.post(urls.admin.users, data).then((res) => res.data),

  updateById: (id, data) =>
    axiosService.patch(`${urls.admin.users}/${id}`, data).then((res) => res.data),
};

export { adminUsersService };


